import { ImageViewerValues } from "./ImageViewerValues";

/**
 * This class facilitates storing/retrieving an image in session storage.  This mechanism is used to pass an image that
 * has already been retrieved to a new tab/window.
 * 
 * By storing the image information in session storage, the information will be discarded when the tab is closed.  Also,
 * the tab can be refreshed and the image will still display correctly.
 */
export class ImageViewerSessionStorage {
    private readonly STORAGE_KEY = "imageViewer.temp";

    get(): ImageViewerValues {
        return JSON.parse(sessionStorage.getItem(this.STORAGE_KEY));
    }

    save(imageValues: ImageViewerValues) {
        if (imageValues != null && Object.keys(imageValues).length > 0) {
            sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(imageValues));   
        } else {
            sessionStorage.removeItem(this.STORAGE_KEY);
        }
    }
}
